"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendEmailDeliveryError = void 0;
var SendEmailDeliveryError;
(function (SendEmailDeliveryError) {
    SendEmailDeliveryError["UnexpectedError"] = "UnexpectedError";
    SendEmailDeliveryError["SenderNoEmail"] = "SenderNoEmail";
    SendEmailDeliveryError["MoreThanTenRecipientsInPreview"] = "MoreThanTenRecipientsInPreview";
    SendEmailDeliveryError["LimitExceeded"] = "LimitExceeded";
    SendEmailDeliveryError["CustomDomainRequired"] = "CustomDomainRequired";
    SendEmailDeliveryError["SendingFailed"] = "SendingFailed";
    SendEmailDeliveryError["StripeAccountNotActive"] = "StripeAccountNotActive";
    SendEmailDeliveryError["EmailDeliveryNotFound"] = "EmailDeliveryNotFound";
    SendEmailDeliveryError["FailedToGetSmartInviteRecipients"] = "FailedToGetSmartInviteRecipients";
    SendEmailDeliveryError["DesignConfigMissing"] = "DesignConfigMissing";
    SendEmailDeliveryError["FailedToGetOwnerEmail"] = "FailedToGetOwnerEmail";
    SendEmailDeliveryError["FailedToGetReminderRecipients"] = "FailedToGetReminderRecipients";
    SendEmailDeliveryError["FailedToGetRecipients"] = "FailedToGetRecipients";
    SendEmailDeliveryError["FormNotFound"] = "FormNotFound";
    SendEmailDeliveryError["NoRecipients"] = "NoRecipients";
    SendEmailDeliveryError["DailyLimitExceeded"] = "DailyLimitExceeded";
    SendEmailDeliveryError["WeeklyLimitExceeded"] = "WeeklyLimitExceeded";
    SendEmailDeliveryError["TestEmailRecipientLimitExceeded"] = "TestEmailRecipientLimitExceeded";
    SendEmailDeliveryError["TestEmailSendLimitExceeded"] = "TestEmailSendLimitExceeded";
    SendEmailDeliveryError["EmailContentNotFound"] = "EmailContentNotFound";
    SendEmailDeliveryError["AlreadyCompletedOrFailed"] = "AlreadyCompletedOrFailed";
})(SendEmailDeliveryError || (exports.SendEmailDeliveryError = SendEmailDeliveryError = {}));
